import { LuChevronDown, LuMaximize2, LuMinimize2 } from 'react-icons/lu';

import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { cn } from '@/utils/cn';

import { useDockState } from './dock-state';
import { DockItemType } from './dock-state-types';
import { CreateNoteDockItem } from './widgets/CreateNoteDockItem';
import { CreateOpportunityDockItem } from './widgets/CreateOpportunityDockItem';
import { CreateTaskDockItem } from './widgets/CreateTaskDockItem';
import { DockItemTitle } from './widgets/DockItemTitle';
import { NoteDockItem } from './widgets/NoteDockItem';
import { TaskDockItem } from './widgets/TaskDockItem';
import { UpdateOpportunityDockItem } from './widgets/UpdateOpportunityDockItem';

export const DockOverlay = () => {
    const { activeId, items, isMaximized, setActiveId, toggleMaximized } = useDockState();

    if (!activeId) return null;

    const dockItem = items.find((item) => item.id === activeId);
    if (!dockItem) return null;

    return (
        <Card
            className={cn('flex flex-col overflow-hidden bg-white shadow-2xl', {
                'h-[80vh] w-[80vw]': isMaximized,
                'max-h-[60vh] w-[600px] max-w-[60vw]': !isMaximized,
            })}
        >
            <CardHeader className="flex flex-shrink-0 flex-row items-center justify-between gap-3">
                <DockItemTitle item={dockItem} isHeader />
                <div className="flex flex-shrink-0 gap-1">
                    <Button variant="ghost" size="icon" onClick={toggleMaximized}>
                        {isMaximized ? <LuMinimize2 /> : <LuMaximize2 />}
                    </Button>
                    <Button variant="ghost" size="icon" onClick={() => setActiveId(null)}>
                        <LuChevronDown />
                    </Button>
                </div>
            </CardHeader>
            <CardContent className="flex-1 overflow-y-auto">
                {dockItem.type === DockItemType.CREATE_NOTE && <CreateNoteDockItem item={dockItem} />}
                {dockItem.type === DockItemType.UPDATE_NOTE && <NoteDockItem item={dockItem} />}
                {dockItem.type === DockItemType.CREATE_TASK && <CreateTaskDockItem item={dockItem} />}
                {dockItem.type === DockItemType.UPDATE_TASK && <TaskDockItem item={dockItem} />}
                {dockItem.type === DockItemType.CREATE_OPPORTUNITY && <CreateOpportunityDockItem item={dockItem} />}
                {dockItem.type === DockItemType.UPDATE_OPPORTUNITY && <UpdateOpportunityDockItem item={dockItem} />}
            </CardContent>
        </Card>
    );
};
